import React, { useEffect, useMemo, useState } from "react";
import FeedbackBanner from "../../general/correct-feedback/FeedbackBanner";
import HtmlContent from "../../general/html-content/HtmlContent";

const normalizeItems = (items) =>
  Array.isArray(items)
    ? items
      .map((item, idx) => ({
        id: String(item?.id || idx + 1),
        text: String(item?.text || ""),
      }))
      .filter((item) => item.id && item.text)
    : [];

const rotateItems = (items) => {
  if (items.length < 2) return items;
  return [...items.slice(1), items[0]];
};

const LogicalSequenceQuestion = ({
  question,
  items,
  questionKey,
  onOrderChange,
  showCheckButton,
  canCheck,
  onCheck,
  feedbackVisible,
  feedback,
  onCloseFeedback,
  showNextButton,
  onNext,
  showFinishButton,
  onFinish,
}) => {
  const normalizedItems = useMemo(() => normalizeItems(items), [items]);
  const [orderedItems, setOrderedItems] = useState(() => rotateItems(normalizedItems));

  useEffect(() => {
    const nextItems = rotateItems(normalizedItems);
    setOrderedItems(nextItems);
    onOrderChange(nextItems.map((item) => item.id));
  }, [normalizedItems, onOrderChange, questionKey]);

  const moveItem = (fromIndex, toIndex) => {
    if (toIndex < 0 || toIndex >= orderedItems.length) return;

    const nextItems = [...orderedItems];
    const [item] = nextItems.splice(fromIndex, 1);
    nextItems.splice(toIndex, 0, item);
    setOrderedItems(nextItems);
    onOrderChange(nextItems.map((nextItem) => nextItem.id));
  };

  const resetOrder = () => {
    const nextItems = rotateItems(normalizedItems);
    setOrderedItems(nextItems);
    onOrderChange(nextItems.map((item) => item.id));
  };

  return (
    <>
      {question && (
        <div
          className="test-question question-title"
          dangerouslySetInnerHTML={{ __html: question }}
        />
      )}

      <div className="logical-sequence-list">
        {orderedItems.map((item, idx) => (
          <div key={item.id} className="logical-sequence-item">
            <span className="logical-sequence-position">{idx + 1}</span>
            <div className="logical-sequence-card">
              <strong>{item.id}</strong>
              <HtmlContent html={item.text} />
            </div>
            <div className="logical-sequence-controls">
              <button
                type="button"
                onClick={() => moveItem(idx, idx - 1)}
                disabled={idx === 0 || feedback === "correct"}
                aria-label="Move item up"
              >
                ↑
              </button>
              <button
                type="button"
                onClick={() => moveItem(idx, idx + 1)}
                disabled={idx === orderedItems.length - 1 || feedback === "correct"}
                aria-label="Move item down"
              >
                ↓
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="logical-sequence-actions">
        <button type="button" className="btn matching-pairs-reset" onClick={resetOrder}>
          Скинути
        </button>

        {showCheckButton && canCheck && (
          <button className="btn checkAnswer" onClick={onCheck} style={{ display: "inline-block" }}>
            Перевірити
          </button>
        )}
      </div>

      {feedbackVisible && <FeedbackBanner feedback={feedback} closeFeedback={onCloseFeedback} />}

      {showNextButton && (
        <button className="btn nextAnswer" onClick={onNext} style={{ display: "inline-block" }}>
          Наступне завдання
        </button>
      )}

      {showFinishButton && (
        <button className="btn nextAnswer" onClick={onFinish} style={{ display: "inline-block" }}>
          Завершити
        </button>
      )}
    </>
  );
};

export default LogicalSequenceQuestion;
